<template>
    <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px pr-2" aria-label="pagination">
        <button @click="pageNumber -= 1" :disabled="pageNumber === 1"
            :class="pageNumber === 1 ? 'bg-gray-50' : 'bg-white'"
            class="inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500">
            <span class="sr-only">Previous</span>
            <ChevronLeftIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <template v-for="p in pager">
            <span v-if="p === -1"
                class="inline-flex items-center px-2 py-2 border-y -mx-1 border-gray-300 bg-white text-sm font-medium text-gray-400">
                ...
            </span>
            <button v-else-if="pageNumber === p" disabled
                class="font-semibold border-2 bg-gray-50 border-gray-300 text-black relative inline-flex items-center px-4 py-2 text-sm">
                {{ p }}
            </button>
            <button v-else type="button" @click="pageNumber = p"
                class="bg-white cursor-pointer border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                {{ p }}
            </button>
        </template>
        <button @click="pageNumber += 1" :disabled="last" :class="last ? 'bg-gray-50' : 'bg-white'"
            class="inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500">
            <span class="sr-only">Next</span>
            <ChevronRightIcon class="h-5 w-5" aria-hidden="true" />
        </button>
    </nav>
</template>

<script lang="ts">
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid'

export default defineComponent({
    props: {
        page: Number,
        count: Number,
        pageSize: Number
    },
    emit: {
        'update:page': (o: number) => true
    },
    components: { ChevronRightIcon, ChevronLeftIcon },
    setup(props, { emit }) {

        return {
            pager: computed(() => generatePager(props.page, props.count, props.pageSize)),
            pageNumber: computed({
                get() { return props.page },
                set(p: number) { emit('update:page', p) }
            }),
            last: computed(() => props.page >= (props.count / props.pageSize))
        }
    }
})

function generatePager(currentPage = 1, countElts = 0, pageSize = 10) {
    if (!countElts) return []

    const countPage = Math.ceil(countElts / pageSize)

    const _pager = [currentPage - 3, currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, currentPage + 3]
        .filter(c => c >= 1 && c <= countPage)

    while (_pager.length > 3)
        _pager.indexOf(currentPage + 1) >= 2 ? _pager.shift() : _pager.pop()

    if (_pager[0] === 2) _pager.unshift(1)
    else if (_pager[0] === 3) _pager.unshift(1, 2)
    else if (_pager[0] !== 1) _pager.unshift(1, -1)

    if (_pager[_pager.length - 1] === (countPage - 1)) _pager.push(countPage)
    else if (_pager[_pager.length - 1] === (countPage - 2)) _pager.push(countPage - 1, countPage)
    else if (_pager[_pager.length - 1] !== countPage) _pager.push(-1, countPage)

    return _pager
}
</script>
